// extracted by mini-css-extract-plugin
export default {"PageContainer":"ErrorPage_PageContainer__QIKay","ErrorHeader":"ErrorPage_ErrorHeader__AD29X","ErrorHeader2":"ErrorPage_ErrorHeader2__bmpKQ"};